import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button, Dropdown } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import {useState, useEffect} from 'react'
import { getLocalReservationConfigurationByLocalId } from '../../../../../../../../../crud/management_api/reservations_configuration'
import { getAvailableReservationSlots, getAvailableTablesForSlot } from '../../../../../../../../../crud/clients_api/client_reservations'
import Calendar from 'react-calendar'
import { X } from 'react-bootstrap-icons'
import { Salon, LocalReservationConfiguration } from './types'
import {toast} from 'react-toastify'
import { createReservation } from '../../../../../../../../../crud/clients_api/client_reservations'
import { FaCalendar } from 'react-icons/fa'
import './ModalCreateReservationV2.scss'
import {Spinner} from 'react-bootstrap'


type Props = {
    Manual?:boolean
    show: boolean;
    setShowCreateModal: (show: boolean) => void;
    salones?: Salon[]; // Lista de salones, opcional
    handleReservationCreated?: () => void; // Callback opcional para manejar la creación de reservaciones
}

const ModalCreateReservationV2 = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const handleCreateReservation = async () => {
        setLoading(true);
        if (!clientName) { setLoading(false); return toast.error('Falta el nombre del cliente'); }
        if (!clientPhone) { setLoading(false); return toast.error('Falta el teléfono'); }
        if (!peopleCount || peopleCount < 1) { setLoading(false); return toast.error('Falta el número de personas'); }
        if (!selectedDate) { setLoading(false); return toast.error('Falta la fecha'); }
        if (!reservationTime) { setLoading(false); return toast.error('Falta la hora de la reservación'); }
        if (!selectedSlot) { setLoading(false); return toast.error('Debes seleccionar un slot de hora'); }
        // Validación de slot según modo manual o automático
        if (!selectMesaActive) {
            if (!availableSlots || !availableSlots[selectedSlot]) { setLoading(false); return toast.error('Slot inválido'); }
        } else {
            // En modo manual, validar que el slot exista en availableSlots
            if (!availableSlots || Object.keys(availableSlots).length === 0) { setLoading(false); return toast.error('Slot inválido'); }
            if (selectedSlot === null || availableSlots[selectedSlot] === undefined) { setLoading(false); return toast.error('Slot inválido'); }
        }

        // Obtener datos de usuario y local
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 1;
        const userId = userContext ? JSON.parse(userContext).user_id : null;
        const emailToUse = clientEmail && clientEmail.trim() ? clientEmail.trim() : null;

        // Si hay mesas sugeridas seleccionadas, crear una reservación por cada una
        if (mesasSugeridasSeleccionadas.length > 0) {
            let successCount = 0;
            let errorCount = 0;
            for (const mesa of mesasSugeridasSeleccionadas) {
                try {
                    await createReservation(
                        localId,
                        selectedDate.toISOString().slice(0, 10),
                        peopleCount,
                        selectedSlot,
                        mesa.id,
                        null,
                        userId,
                        clientName,
                        emailToUse,
                        clientPhone,
                        notes || ''
                    );
                    successCount++;
                } catch (err) {
                    errorCount++;
                }
            }
            if (successCount > 0) toast.success(`Reservación${successCount > 1 ? 'es' : ''} creada${successCount > 1 ? 's' : ''} correctamente`);
            if (errorCount > 0) toast.error(`Error al crear ${errorCount} reservación${errorCount > 1 ? 'es' : ''}`);
            // Limpiar todos los campos y estados
            setClientName('');
            setClientPhone('');
            setClientEmail('');
            setPeopleCount(1);
            setNotes('');
            setSelectedDate(null);
            setReservationTime('');
            setSelectedSlot(null);
            setSlotSelected(false);
            setMesasSugeridasSeleccionadas([]);
            setSelectMesaActive(false);
            props.setShowCreateModal(false);
            setLoading(false);
            if (props.handleReservationCreated) props.handleReservationCreated();
            return;
        }

        // Si no hay mesas sugeridas seleccionadas, crear la reservación normal
        try {
            let mesaSugerida = null;
            if (!selectMesaActive) {
                mesaSugerida = availableSlots && availableSlots[selectedSlot] ? availableSlots[selectedSlot].mesas_sugeridas[0] : null;
            } else {
                // En modo manual, si hay mesas disponibles, tomar la primera como sugerida
                if (manualTables && manualTables.length > 0) {
                    mesaSugerida = manualTables[0].mesa_id;
                }
            }
            await createReservation(
                localId,
                selectedDate.toISOString().slice(0, 10),
                peopleCount,
                selectedSlot,
                mesaSugerida,
                null,
                userId,
                clientName,
                emailToUse,
                clientPhone,
                notes || ''
            );
            toast.success('Reservación creada correctamente');
            // Limpiar todos los campos y estados
            setClientName('');
            setClientPhone('');
            setClientEmail('');
            setPeopleCount(1);
            setNotes('');
            setSelectedDate(null);
            setReservationTime('');
            setSelectedSlot(null);
            setSlotSelected(false);
            setMesasSugeridasSeleccionadas([]);
            setSelectMesaActive(false);
            props.setShowCreateModal(false);
            setLoading(false);
            if (props.handleReservationCreated) props.handleReservationCreated();
        } catch (err) {
            toast.error('Error al crear la reservación');
            setLoading(false);
        }
    };
  
    const [selectedSlot, setSelectedSlot] = useState<number | null>(null);
    const [slotSelected, setSlotSelected] = useState(false);
    const [horaSeleccionada, setHoraSeleccionada] = useState(false);
    const [minutoSeleccionado, setMinutoSeleccionado] = useState(false);
    const [clientName, setClientName] = React.useState('');
    const [clientPhone, setClientPhone] = React.useState('');
    const [clientEmail, setClientEmail] = React.useState('');
    const [reservationTime, setReservationTime] = React.useState('');
    const [peopleCount, setPeopleCount] = React.useState(1);
    const [notes, setNotes] = React.useState('');
    const [mesasSugeridasSeleccionadas, setMesasSugeridasSeleccionadas] = React.useState<{id: number, num: string}[]>([]);
    const [selectMesaActive, setSelectMesaActive] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
    const [availableSlots, setAvailableSlots] = useState<Record<string, { slot: number; mesas_sugeridas: number[] }> | null>(null);
    const [showCalendar, setShowCalendar] = React.useState(false);
    const toggleCalendar = () => setShowCalendar((prev) => !prev);

    // Consulta de slots cuando se selecciona una fecha
    interface AvailableTable {
        mesa_id: number;
        mesa_number: string;
        tag: string;
        capacity: number;
        salon_id: number;
    }
    
    const [manualTables, setManualTables] = useState<AvailableTable[]>([]);
    const [loadingManualTables, setLoadingManualTables] = useState(false);
    const handleDateChange = async (date: Date) => {
        setSelectedDate(date);
        setShowCalendar(false);
        // Obtener el localId del contexto actual
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        const reservationDate = date.toISOString().slice(0, 10);
        const nPeople = peopleCount;
        const salonId = null;
        try {
            const res = await getAvailableReservationSlots(localId, reservationDate, nPeople, salonId);
            if (res.data && res.data.message === "No tables available for the specified number of people") {
                toast.warning("No hay mesas disponibles para ese número de personas. Debes seleccionar las mesas manualmente.");
                setSelectMesaActive(true);
                setAvailableSlots(null);
                setManualTables([]);
            } else {
                setAvailableSlots(res.data);
                setManualTables([]);
                setSelectMesaActive(false);
            }
        } catch (err) {
            // Manejo específico para error 400 con mensaje del backend
            let backendMsg: string | undefined = undefined;
            if (err && typeof err === 'object' && 'response' in err && (err as any).response?.data?.message) {
                backendMsg = (err as any).response.data.message;
            }
            if (backendMsg === "No tables available for the specified number of people") {
                toast.warning("No hay mesas disponibles para ese número de personas. Debes seleccionar las mesas manualmente.");
                setSelectMesaActive(true);
                setAvailableSlots(null);
                setManualTables([]);
            } else {
                toast.error("Error al consultar disponibilidad de mesas.");
                setAvailableSlots(null);
                setManualTables([]);
                setSelectMesaActive(false);
            }
        }
    };

    // Estados para almacenar los datos de las consultas
    const [reservationConfig, setReservationConfig] = useState<LocalReservationConfiguration | null>(null);

    // Only fetch reservation configuration when modal is shown
    useEffect(() => {
        if (!props.show) {
            return;
        }

        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        getLocalReservationConfigurationByLocalId(localId).then(res => {
            setReservationConfig(res.data);
        });
    }, [props.show]);

    // Fetch available tables when manual mode is active and slot is selected
    useEffect(() => {
        const fetchManualTables = async () => {
            if (!selectMesaActive || selectedSlot === null || !selectedDate || !reservationConfig) {
                return;
            }

            const userContext = localStorage.getItem('user');
            const localId = userContext ? JSON.parse(userContext).local_id : 0;
            const reservationDate = selectedDate.toISOString().slice(0, 10);
            const durationSlots = 4; // Default duration slots
            const salonId = null; // or get from props if needed

            setLoadingManualTables(true);
            try {
                const res = await getAvailableTablesForSlot(
                    localId,
                    reservationDate,
                    selectedSlot,
                    peopleCount,
                    durationSlots,
                    salonId
                );
                
                if (res.data && res.data.available_tables) {
                    setManualTables(res.data.available_tables);
                } else {
                    setManualTables([]);
                }
            } catch (err) {
                console.error('Error fetching available tables:', err);
                toast.error('No se pudieron obtener las mesas disponibles');
                setManualTables([]);
            } finally {
                setLoadingManualTables(false);
            }
        };

        fetchManualTables();
    }, [selectMesaActive, selectedSlot, selectedDate, peopleCount, reservationConfig]);

    // Utilidad para obtener los slots permitidos según el día seleccionado (intervalos de 15 minutos)
    function getAllowedSlotsForSelectedDay() {
        if (!reservationConfig || !selectedDate) return [];
        const dayOfWeek = selectedDate.getDay() === 0 ? 7 : selectedDate.getDay(); // Domingo=0 -> 7
        const dayConfig = reservationConfig.object.reservation_days?.[dayOfWeek];
        if (!dayConfig || !Array.isArray(dayConfig)) return [];
        let slots: number[] = [];
        dayConfig.forEach((range: number[]) => {
            const [from, to] = range;
            for (let s = from; s <= to; s++) {
                // Solo permitir slots válidos para 15 min: 0 a 95 (00:00 a 23:45)
                if (s >= 0 && s <= 95) {
                    slots.push(s);
                }
            }
        });
        return slots;
    }

    // Utilidad para convertir slot a hora y minutos (15 minutos por slot)
    function slotToHourMinute(slot: number): { hour: number, minute: number } {
        // Slot 0 = 00:00, Slot 1 = 00:15, ..., Slot 48 = 12:00, ..., Slot 95 = 23:45
        const minutes = slot * 15;
        const hour = Math.floor(minutes / 60);
        const minute = minutes % 60;
        return { hour, minute };
    }

    // Generar arrays de horas y minutos válidos según los slots permitidos
    const allowedSlots = getAllowedSlotsForSelectedDay();
    const allowedTimes = allowedSlots.map(slotToHourMinute);
    // Obtener la hora y minutos actuales
    const now = new Date();
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();
    // Si la fecha seleccionada es diferente a hoy, mostrar todas las horas
    let filterFromNow = false;
    if (selectedDate) {
      const isToday = now.toISOString().slice(0,10) === selectedDate.toISOString().slice(0,10);
      filterFromNow = isToday;
    }
    // Filtrar horas y minutos permitidos desde la hora actual en adelante si es hoy
    const allowedHours = Array.from(new Set(
      allowedTimes
        .filter(t => !filterFromNow || t.hour > currentHour || (t.hour === currentHour && t.minute >= currentMinute))
        .map(t => t.hour)
    )).sort((a,b) => a-b);
    const selectedHour = Number(reservationTime.split(':')[0]);
    const allowedMinutes = allowedTimes
      .filter(t => t.hour === selectedHour && (!filterFromNow || t.hour > currentHour || (t.hour === currentHour && t.minute >= currentMinute)))
      .map(t => t.minute);
    const allowedMinutesUnique = Array.from(new Set(allowedMinutes)).sort((a,b) => a-b);

    return (
        <Modal 
            show={props.show} 
            onHide={() => props.setShowCreateModal(false)} 
            className='modal-create-reservationv2'
            centered
            backdrop="static"
            size="lg"
        >
            <Modal.Header>
                <div className='form-modal-title-container'>
                    <Modal.Title className='form-modal-title'>Nueva Reservación</Modal.Title>
                </div>
                <button className="modal-close-button" onClick={() => props.setShowCreateModal(false)}>
                    <X size={20} />
                </button>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Client Information - Row 1: Nombre completo */}
                    <div className="row g-3 mb-3">
                        <div className="col-12">
                            <div className="form-field">
                                <label className="field-label">Nombre completo</label>
                                <input
                                    type="text"
                                    value={clientName}
                                    onChange={e => setClientName(e.target.value)}
                                    className="modern-input"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Row 2: Teléfono and Email */}
                    <div className="row g-3 mb-3">
                        <div className="col-md-6">
                            <div className="form-field">
                                <label className="field-label">Teléfono</label>
                                <input
                                    type="tel"
                                    value={clientPhone}
                                    onChange={e => setClientPhone(e.target.value)}
                                    className="modern-input"
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-field">
                                <label className="field-label">Email (opcional)</label>
                                <input
                                    type="email"
                                    value={clientEmail}
                                    onChange={e => setClientEmail(e.target.value)}
                                    className="modern-input"
                                    placeholder="ejemplo@correo.com"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Row 3: Número de personas */}
                    <div className="row g-3 mb-4">
                        <div className="col-12">
                            <div className="form-field">
                                <label className="field-label">Número de personas</label>
                                <Dropdown onSelect={(eventKey) => setPeopleCount(Number(eventKey))}>
                                    <Dropdown.Toggle variant="none" className="modern-input">
                                        {peopleCount} {peopleCount === 1 ? 'persona' : 'personas'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-scrollable w-100">
                                        {Array.from({ length: 15 }, (_, i) => i + 1).map(num => (
                                            <Dropdown.Item eventKey={num.toString()} key={num}>
                                                {num} {num === 1 ? 'persona' : 'personas'}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>

                    {/* Date - Full row */}
                    <div className="row g-3 mb-4">
                        <div className="col-12">
                            <div className="form-field">
                                <label className="field-label">Fecha</label>
                                <button
                                    type="button"
                                    onClick={toggleCalendar}
                                    className="date-picker-btn"
                                >
                                    <FaCalendar />
                                    <span>
                                        {selectedDate ? selectedDate.toLocaleDateString('es-ES', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                        }) : 'Seleccionar Fecha'}
                                    </span>
                                </button>
                                {showCalendar && (
                                    <div className='mp-form-calendar-container'>
                                        <Calendar
                                            onChange={date => handleDateChange(date as Date)}
                                            value={selectedDate}
                                            locale="es-ES"
                                            className="mp-form-calendar"
                                            minDate={new Date()}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Time - Full row */}
                    <div className="row g-3 mb-4">
                        <div className="col-12">
                            <div className="form-field">
                                <label className="field-label">Hora</label>
                                <div className="time-picker-grid">
                                    <Dropdown onSelect={(eventKey) => {
                                        const min = reservationTime.split(':')[1] || '';
                                        const newHour = eventKey || '';
                                        setReservationTime(`${newHour}:${min}`);
                                        setSlotSelected(false);
                                        setSelectedSlot(null);
                                        setHoraSeleccionada(true);
                                        setMinutoSeleccionado(false);
                                    }}>
                                        <Dropdown.Toggle variant="none" className="modern-input text-center">
                                            {reservationTime.split(':')[0] || 'Hora'}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-scrollable">
                                            {allowedHours.length === 0 && <Dropdown.Item disabled>No disponible</Dropdown.Item>}
                                            {allowedHours.map(h => (
                                                <Dropdown.Item eventKey={h.toString().padStart(2, '0')} key={h}>
                                                    {h.toString().padStart(2, '0')}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    
                                    <span className="time-separator">:</span>
                                    
                                    <Dropdown onSelect={(eventKey) => {
                                        const h = reservationTime.split(':')[0] || '';
                                        const newMin = eventKey || '';
                                        setReservationTime(`${h}:${newMin}`);
                                        setSlotSelected(false);
                                        setSelectedSlot(null);
                                        setMinutoSeleccionado(true);
                                    }}>
                                        <Dropdown.Toggle 
                                            variant="none" 
                                            className="modern-input text-center" 
                                            disabled={!selectedHour || allowedMinutesUnique.length === 0}
                                        >
                                            {reservationTime.split(':')[1] || 'Min'}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-scrollable">
                                            {allowedMinutesUnique.length === 0 && <Dropdown.Item disabled>No disponible</Dropdown.Item>}
                                            {allowedMinutesUnique.map(m => (
                                                <Dropdown.Item eventKey={m.toString().padStart(2, '0')} key={m}>
                                                    {m.toString().padStart(2, '0')}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Available Slots */}
                    {(!slotSelected && horaSeleccionada && minutoSeleccionado) && (
                        <div className="slots-section mb-3">
                            {selectMesaActive && manualTables && Object.keys(manualTables).length > 0 && reservationTime.split(':').length === 2 && reservationTime.split(':')[0] && reservationTime.split(':')[1]
                                ? (() => {
                                    const [hour, minute] = reservationTime.split(':').map(Number);
                                    if (isNaN(hour) || isNaN(minute)) return null;
                                    return (
                                        <div className='slots-grid'>
                                            {(() => {
                                                const timeInMinutes = hour * 60 + minute;
                                                const slotKeys = Object.keys(manualTables).map(Number).sort((a,b) => a-b);
                                                let closestSlot = slotKeys[0];
                                                let minDiff = Infinity;
                                                slotKeys.forEach(slot => {
                                                    const slotMinutes = slot * 15;
                                                    const diff = Math.abs(slotMinutes - timeInMinutes);
                                                    if (diff < minDiff) {
                                                        minDiff = diff;
                                                        closestSlot = slot;
                                                    }
                                                });
                                                const idx = slotKeys.indexOf(closestSlot);
                                                const start = Math.max(0, idx - 2);
                                                const end = Math.min(slotKeys.length, idx + 3);
                                                const visibleSlots = slotKeys.slice(start, end);
                                                function slotToHour(slot: number): string {
                                                    const minutes = slot * 15;
                                                    const hour = Math.floor(minutes / 60);
                                                    const minute = minutes % 60;
                                                    return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                                                }
                                                return visibleSlots.map(slot => (
                                                    <button
                                                        key={slot}
                                                        type="button"
                                                        className={`slot-card ${selectedSlot === slot ? 'selected' : ''}`}
                                                        onClick={() => {
                                                            setSelectedSlot(slot);
                                                            setReservationTime(slotToHour(slot));
                                                            setSlotSelected(true);
                                                        }}
                                                    >
                                                        {slotToHour(slot)}
                                                    </button>
                                                ));
                                            })()}
                                        </div>
                                    );
                                })()
                                : (
                                    availableSlots && reservationTime && reservationTime.split(':').length === 2 && reservationTime.split(':')[0] && reservationTime.split(':')[1] && (
                                        (() => {
                                            const [hour, minute] = reservationTime.split(':').map(Number);
                                            if (isNaN(hour) || isNaN(minute)) return null;
                                            let slotKeys = Object.keys(availableSlots).map(Number).sort((a,b) => a-b);
                                            const now = new Date();
                                            if (selectedDate && now.toISOString().slice(0,10) === selectedDate.toISOString().slice(0,10)) {
                                                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                                slotKeys = slotKeys.filter(slot => (slot * 15) >= currentMinutes);
                                            }
                                            if (slotKeys.length === 0) return <div className='text-center text-muted'>No hay horarios disponibles</div>;
                                            let closestSlot = slotKeys[0];
                                            let minDiff = Infinity;
                                            const timeInMinutes = hour * 60 + minute;
                                            slotKeys.forEach(slot => {
                                                const slotMinutes = slot * 15;
                                                const diff = Math.abs(slotMinutes - timeInMinutes);
                                                if (diff < minDiff) {
                                                    minDiff = diff;
                                                    closestSlot = slot;
                                                }
                                            });
                                            const idx = slotKeys.indexOf(closestSlot);
                                            let start = idx - 2;
                                            let end = idx + 3;
                                            if (start < 0) {
                                                end += -start;
                                                start = 0;
                                            }
                                            if (end > slotKeys.length) {
                                                start -= (end - slotKeys.length);
                                                end = slotKeys.length;
                                                if (start < 0) start = 0;
                                            }
                                            const visibleSlots = slotKeys.slice(start, end);
                                            function slotToHour(slot: number): string {
                                                const minutes = slot * 15;
                                                const hour = Math.floor(minutes / 60);
                                                const minute = minutes % 60;
                                                return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                                            }
                                            return (
                                                <div className='slots-grid'>
                                                    {visibleSlots.map(slot => (
                                                        <button
                                                            key={slot}
                                                            type="button"
                                                            className={`slot-card ${selectedSlot === slot ? 'selected' : ''}`}
                                                            onClick={() => {
                                                                setSelectedSlot(slot);
                                                                setReservationTime(slotToHour(slot));
                                                                setSlotSelected(true);
                                                            }}
                                                        >
                                                            {slotToHour(slot)}
                                                        </button>
                                                    ))}
                                                </div>
                                            );
                                        })()
                                    )
                                )}
                        </div>
                    )}

                    {/* Table Selection - Only show when date, slot, and people count are selected */}
                    {selectedDate && selectedSlot !== null && peopleCount > 0 && (
                        <div className="row g-3 mb-3">
                            <div className="col-12">
                                <div className="table-selection-header">
                                    <label className="field-label">Selección de Mesa</label>
                                    <div className="custom-switch-container">
                                        <input
                                            type="checkbox"
                                            id="table-switch"
                                            checked={selectMesaActive}
                                            onChange={() => setSelectMesaActive(!selectMesaActive)}
                                            className="custom-switch-input"
                                        />
                                        <label htmlFor="table-switch" className="custom-switch-label">
                                            <span className="custom-switch-slider"></span>
                                            <span className="custom-switch-text">Manual</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {selectMesaActive && (
                                <div className="col-12">
                                    {loadingManualTables ? (
                                        <div className="loading-tables-message">
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Cargando mesas disponibles...
                                        </div>
                                    ) : (
                                        <Dropdown onSelect={eventKey => {
                                            const selectedId = Number(eventKey);
                                            if (!selectedId) return;
                                            // Find mesa from manualTables
                                            const mesa = manualTables.find(m => m.mesa_id === selectedId);
                                            // Prioritize tag over mesa_number
                                            const mesaDisplay = mesa ? (mesa.tag || mesa.mesa_number.toString()) : selectedId.toString();
                                            
                                            if (!mesasSugeridasSeleccionadas.some(m => m.id === selectedId)) {
                                                setMesasSugeridasSeleccionadas(prev => [...prev, {id: selectedId, num: mesaDisplay}]);
                                            }
                                        }}>
                                            <Dropdown.Toggle variant="none" className="modern-input w-100">
                                                Seleccionar mesa
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="w-100 dropdown-scrollable">
                                                {manualTables.length > 0
                                                    ? manualTables
                                                        .filter((mesa) => !mesasSugeridasSeleccionadas.some(m => m.id === mesa.mesa_id))
                                                        .map((mesa) => (
                                                            <Dropdown.Item eventKey={mesa.mesa_id} key={mesa.mesa_id}>
                                                                {mesa.tag || mesa.mesa_number} - {mesa.capacity}p
                                                            </Dropdown.Item>
                                                        ))
                                                    : (
                                                        <Dropdown.Item disabled>
                                                            No hay mesas disponibles
                                                        </Dropdown.Item>
                                                    )
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                    
                                    {mesasSugeridasSeleccionadas.length > 0 && (
                                    <div className="selected-tables mt-2">
                                        {mesasSugeridasSeleccionadas.map(mesa => (
                                            <div key={mesa.id} className="table-chip">
                                                <span>{mesa.num}</span>
                                                <button 
                                                    type="button"
                                                    className='remove-btn' 
                                                    onClick={() => setMesasSugeridasSeleccionadas(prev => prev.filter(m => m.id !== mesa.id))}
                                                >
                                                    <X size={14} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                        </div>
                    )}

                    {/* Notes */}
                    <div className="row g-3">
                        <div className="col-12">
                            <div className="form-field">
                                <label className="field-label">Notas adicionales</label>
                                <textarea
                                    rows={2}
                                    value={notes}
                                    onChange={e => setNotes(e.target.value)}
                                    className="modern-input"
                                    placeholder="Opcional"
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-modal-footer-custom">
                    <Button variant="none" className='form-button-cancel' onClick={() => props.setShowCreateModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="none" className='form-button-create' onClick={handleCreateReservation} disabled={loading}>
                        {loading ? (
                            <>
                                <Spinner animation="border" size="sm" />
                                <span>Creando...</span>
                            </>
                        ) : (
                            'Crear Reservación'
                        )}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalCreateReservationV2